import request from '@/utils/request'

const integralRules = {
  name: 'integralRules',
  state: {
    isIntegralRulesDetailLoading: false,
    integralRulesDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_INTEGRALRULES_DETAIL_LOADING: (state, data) => {
      state.isIntegralRulesDetailLoading = data
    },
    SET_MODULES_INTEGRALRULES_DETAIL_DATA: (state, data) => {
      state.integralRulesDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryIntegralRulesDetailData({ commit }, id) {
      commit('SET_IS_MODULES_INTEGRALRULES_DETAIL_LOADING', true)
      commit('SET_MODULES_INTEGRALRULES_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/integralRules/integralRulesDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_INTEGRALRULES_DETAIL_LOADING', false)
          commit('SET_MODULES_INTEGRALRULES_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_INTEGRALRULES_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetIntegralRulesDetailData({ commit }) {
      commit('SET_MODULES_INTEGRALRULES_DETAIL_DATA', {})
    },
    //  账号新增页面数据
    setIntegralRulesDetailData({ commit }, data) {
      commit('SET_MODULES_INTEGRALRULES_DETAIL_DATA', data)
    }
  }
}

export default integralRules
